export const finalists = [
  {
    id: "bf-01",
    title: "凌晨三点的办公室灯光",
    category: "scene",
    categoryName: "名场面爆料",
    author: "匿名网友 · 阿桃",
    summary:
      "一张深夜办公楼照片引出整层楼的加班日常，配文只有一句话，却让无数打工人瞬间破防。",
    score: 9.6,
    votes: 18420,
    rankChange: 2,
    trend: "up",
    tags: ["打工人", "深夜", "共鸣"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20lone%20lit%20office%20window%20at%20midnight%20in%20a%20dark%20city%20skyline%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20dramatic%20minimal%20composition%2C%20poster%20style&width=800&height=600&seq=baoliao-finalist-01&orientation=landscape",
  },
  {
    id: "bf-02",
    title: "年会抽奖箱里的隐秘纸条",
    category: "reversal",
    categoryName: "高能反转",
    author: "匿名网友 · 小满",
    summary:
      "年会抽奖开出全场最大奖，获奖者却当场把纸条读了出来，剧情走向让整个会场笑成一片。",
    score: 9.4,
    votes: 16380,
    rankChange: 1,
    trend: "up",
    tags: ["年会", "反转", "全场爆笑"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20festive%20lucky%20draw%20box%20spilling%20folded%20notes%20on%20a%20stage%2C%20warm%20cream%20background%20with%20vivid%20red%20and%20gold%20accents%2C%20playful%20poster%20composition&width=800&height=600&seq=baoliao-finalist-02&orientation=landscape",
  },
  {
    id: "bf-03",
    title: "电梯里那句没说完的话",
    category: "heart",
    categoryName: "情感大瓜",
    author: "匿名网友 · 晚风",
    summary:
      "一段电梯监控般视角的文字记录，两个人擦肩时欲言又止的对话，被网友称为年度最意难平。",
    score: 9.2,
    votes: 14120,
    rankChange: 0,
    trend: "steady",
    tags: ["意难平", "文字向", "细腻"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20two%20silhouettes%20passing%20inside%20a%20narrow%20elevator%20with%20soft%20light%2C%20warm%20cream%20background%20with%20muted%20red%20and%20gold%20accents%2C%20quiet%20emotional%20poster%20composition&width=800&height=600&seq=baoliao-finalist-03&orientation=landscape",
  },
  {
    id: "bf-04",
    title: "会议室白板上的涂鸦",
    category: "funny",
    categoryName: "沙雕名镜头",
    author: "匿名网友 · 大熊",
    summary:
      "严肃季度会开到一半，镜头扫到白板角落，有人把整场 KPI 画成了一只会飞的猪。",
    score: 9.0,
    votes: 12960,
    rankChange: 3,
    trend: "up",
    tags: ["打工人", "解压", "神操作"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20meeting%20room%20whiteboard%20covered%20with%20playful%20doodles%20of%20a%20flying%20pig%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20humorous%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-04&orientation=landscape",
  },
  {
    id: "bf-05",
    title: "食堂阿姨多打的那一勺",
    category: "heart",
    categoryName: "情感大瓜",
    author: "匿名网友 · 小鹿",
    summary:
      "连续一个月加班到很晚，某天食堂阿姨默默多打了一勺菜，还说了句“今天辛苦了”。",
    score: 8.9,
    votes: 11840,
    rankChange: 1,
    trend: "up",
    tags: ["温暖", "陌生善意", "治愈"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20canteen%20counter%20with%20a%20kind%20gesture%20and%20a%20steaming%20bowl%2C%20warm%20cream%20background%20with%20soft%20red%20and%20gold%20accents%2C%20heartwarming%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-05&orientation=landscape",
  },
  {
    id: "bf-06",
    title: "拍摄现场道具穿帮合集",
    category: "backstage",
    categoryName: "幕后花絮",
    author: "匿名网友 · 阿柚",
    summary:
      "整理了某剧组一连串道具穿帮瞬间，从矿泉水瓶到手机壳，网友看完表示“再看一遍就回不去了”。",
    score: 8.8,
    votes: 11020,
    rankChange: -2,
    trend: "down",
    tags: ["幕后", "细节控", "合集"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20film%20set%20with%20cameras%20and%20props%20scattered%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20behind%20the%20scenes%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-06&orientation=landscape",
  },
  {
    id: "bf-07",
    title: "那条被顶上热评的第二楼",
    category: "comment",
    categoryName: "神评论截图",
    author: "匿名网友 · 麦子",
    summary:
      "一篇平平无奇的生活分享，二楼一条评论直接改写整个故事走向，楼中楼接了两千多条。",
    score: 8.7,
    votes: 10460,
    rankChange: 4,
    trend: "up",
    tags: ["神评论", "楼中楼", "高能"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20stacked%20chat%20comment%20cards%20with%20a%20highlighted%20reply%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20clean%20graphic%20poster%20composition&width=800&height=600&seq=baoliao-finalist-07&orientation=landscape",
  },
  {
    id: "bf-08",
    title: "直播镜头前的一秒愣神",
    category: "scene",
    categoryName: "名场面爆料",
    author: "匿名网友 · 阿久",
    summary:
      "正讲得投入的直播，突然被弹幕一条提问打断，那不足一秒的愣神被网友截了几十万次。",
    score: 8.6,
    votes: 9860,
    rankChange: -1,
    trend: "down",
    tags: ["直播", "名场面", "破防"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20livestream%20ring%20light%20and%20camera%20with%20floating%20comment%20bubbles%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20dynamic%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-08&orientation=landscape",
  },
  {
    id: "bf-09",
    title: "外卖备注栏里的长信",
    category: "heart",
    categoryName: "情感大瓜",
    author: "匿名网友 · 小南",
    summary:
      "一份普通外卖的备注栏里，顾客写下了一整段对家人的道歉，骑手拍照时手都停了一下。",
    score: 8.5,
    votes: 9120,
    rankChange: 2,
    trend: "up",
    tags: ["温柔", "生活", "治愈"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20takeaway%20bag%20and%20a%20handwritten%20note%20under%20warm%20light%2C%20warm%20cream%20background%20with%20soft%20red%20and%20gold%20accents%2C%20gentle%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-09&orientation=landscape",
  },
  {
    id: "bf-10",
    title: "群聊里发错的那张图",
    category: "reversal",
    categoryName: "高能反转",
    author: "匿名网友 · 阿哲",
    summary:
      "家庭群里长辈发错一张截图，本以为要尴尬收场，结果全家接龙式回复把气氛推上了巅峰。",
    score: 8.4,
    votes: 8640,
    rankChange: 5,
    trend: "up",
    tags: ["家庭群", "社死", "接龙"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20phone%20screen%20with%20a%20family%20group%20chat%20and%20reaction%20emojis%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20playful%20graphic%20poster%20composition&width=800&height=600&seq=baoliao-finalist-10&orientation=landscape",
  },
  {
    id: "bf-11",
    title: "通勤路上被让出的半个座位",
    category: "scene",
    categoryName: "名场面爆料",
    author: "匿名网友 · 木木",
    summary:
      "早高峰挤到变形的地铁上，陌生人默默挪出半个位置并拍了拍旁边的空档，全程没有一句话。",
    score: 8.3,
    votes: 7980,
    rankChange: 1,
    trend: "up",
    tags: ["通勤", "善意", "日常"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20crowded%20subway%20carriage%20with%20a%20quiet%20kind%20gesture%2C%20warm%20cream%20background%20with%20muted%20red%20and%20gold%20accents%2C%20minimal%20poster%20composition&width=800&height=600&seq=baoliao-finalist-11&orientation=landscape",
  },
  {
    id: "bf-12",
    title: "存档界面的最后一格",
    category: "funny",
    categoryName: "沙雕名镜头",
    author: "匿名网友 · 小胖",
    summary:
      "朋友说自己“随便玩了下”，直到截图显示存档时间已经累积到四位数小时，弹幕瞬间安静了。",
    score: 8.2,
    votes: 7420,
    rankChange: 3,
    trend: "up",
    tags: ["游戏", "时间刺客", "名场面"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20game%20save%20screen%20with%20an%20absurd%20playtime%20counter%2C%20warm%20cream%20background%20with%20red%20and%20gold%20accents%2C%20humorous%20graphic%20poster%20composition&width=800&height=600&seq=baoliao-finalist-12&orientation=landscape",
  },
];